// BMI / Health Calculators Tool — BMI hub plus BMR and ideal-weight calculators.
import { m } from "@/paraglide/messages";
import type { Tool } from "../index";
import { CALCULATORS } from "./calculators";

export const bmiCalculatorTool: Tool = {
  id: "bmi-calculator",
  name: () => m.bmi_tool_name(),
  description: () => m.bmi_tool_description(),
  icon: "🩺",
  basePath: "/bmi-calculator",
  status: "stable",
  tags: ["health", "bmi", "fitness", "calculator"],
  pages: [
    {
      name: () => m.bmi_nav_main(),
      path: "/bmi-calculator",
      description: () => m.bmi_nav_main_desc(),
      icon: "🩺",
    },
    {
      name: () => CALCULATORS["bmr-calculator"].navName(),
      path: "/bmi-calculator/bmr-calculator",
      description: () => m.bmi_nav_calc_desc(),
      icon: "🔥",
    },
    {
      name: () => CALCULATORS["ideal-weight"].navName(),
      path: "/bmi-calculator/ideal-weight",
      description: () => m.bmi_nav_calc_desc(),
      icon: "⚖️",
    },
  ],
};
